<div class="modal-content">
  <div class="modal-header">
    <h3>Edit Component: {{ component?.name }}</h3>
    <button class="close-button" (click)="close()">×</button>
  </div>

  @if (component) {
  <div class="modal-body">
    <div class="form-group">
      <label for="compWidth">Width (Cols):</label>
      <input
        id="compWidth"
        type="number"
        [value]="component.cols"
        (input)="component.cols = nativeInputNumber($event)"
      />
    </div>
    <div class="form-group">
      <label for="compHeight">Height (Rows):</label>
      <input
        id="compHeight"
        type="number"
        [value]="component.rows"
        (input)="component.rows = nativeInputNumber($event)"
      />
    </div>
    <div class="form-group">
      <label for="compX">X Position:</label>
      <input
        id="compX"
        type="number"
        [value]="component.x"
        (input)="component.x = nativeInputNumber($event)"
      />
    </div>
    <div class="form-group">
      <label for="compY">Y Position:</label>
      <input
        id="compY"
        type="number"
        [value]="component.y"
        (input)="component.y = nativeInputNumber($event)"
      />
    </div>
    <div class="form-group">
      <label for="autoHeight">Auto Height:</label>
      <input
        id="autoHeight"
        type="checkbox"
        [checked]="component.inputs['autoHeight'].value"
        (change)="onAutoHeightChange(nativeCheckboxChecked($event))"
      />
      <span class="help-text"
        >Allow component to expand height automatically based on content, using
        page scrolling instead of component-level scrolling</span
      >
    </div>
    <div class="form-group">
      <label for="customID">Custom ID:</label>
      <input
        id="customID"
        type="text"
        [value]="component.settings['customID'].value"
        (input)="component.settings['customID'].value = nativeInputValue($event)"
      />
    </div>
    <div class="form-group">
      <label for="compClasses">Custom Classes:</label>
      <input
        id="compClasses"
        type="text"
        [value]="component.settings['customClasses'].value"
        (input)="
          component.settings['customClasses'].value = nativeInputValue($event)
        "
      />
    </div>
    <div class="form-group">
      <label for="fullBleed">Full Bleed (ingen margin):</label>
      <input
        id="fullBleed"
        type="checkbox"
        [checked]="component.settings['fullBleed'].value"
        (change)="
          component.settings['fullBleed'].value = nativeCheckboxChecked($event)
        "
      />
      <span class="help-text"
        >Aktivér for at komponenten går kant-til-kant uden den automatiske 14px
        margen på siden. Bruges til komponenter der selv styrer deres indre
        afstand (fx en full-bleed billedsektion). Dynamic-tabs og
        frontpage-komponenter er altid full-bleed uanset denne
        indstilling.</span
      >
    </div>
    <div class="form-group css-shortcuts">
      <label for="cssShortcuts">CSS Shortcuts:</label>
      <div class="shortcut-controls">
        <app-edit-modal-native-select
          selectId="cssShortcuts"
          [value]="selectedCssShortcut"
          [options]="cssShortcutOptions"
          (valueChange)="selectedCssShortcut = $event"
        />
        <button type="button" (click)="addCssShortcut()">Add</button>
      </div>
    </div>
    <div class="form-group">
      <label for="compCSS">Custom CSS:</label>
      <textarea
        id="compCSS"
        [value]="component.customCSS"
        (input)="component.customCSS = nativeInputValue($event)"
      ></textarea>
    </div>
    <!-- Dynamic Table Sort Settings -->
    @if (component.name === 'DynamicTableComponent') {
    <div class="form-group">
      <label for="defaultSortColumn">Default Sort Column:</label>
      <input
        id="defaultSortColumn"
        type="text"
        [value]="component.settings['defaultSortColumn'].value"
        (input)="
          component.settings['defaultSortColumn'].value =
            nativeInputValue($event)
        "
      />
      <div class="help-text">
        Enter the exact column key to sort by when the table loads (e.g.,
        'created_date', 'name', 'id'). Leave empty for no initial sorting.
      </div>
    </div>
    <div class="form-group">
      <label for="defaultSortDirection">Default Sort Direction:</label>
      <app-edit-modal-native-select
        selectId="defaultSortDirection"
        [value]="component.settings['defaultSortDirection'].value"
        [options]="sortDirectionOptions"
        (valueChange)="component.settings['defaultSortDirection'].value = $event"
      />
      <div class="help-text">
        Only applies when you specify a Default Sort Column above.
      </div>
    </div>
    <div class="form-group">
      <label for="focusSearchOnLoad">Focus search on load:</label>
      <input
        id="focusSearchOnLoad"
        type="checkbox"
        [checked]="component.settings['focusSearchOnLoad'].value"
        (change)="
          component.settings['focusSearchOnLoad'].value =
            nativeCheckboxChecked($event)
        "
      />
      <span class="help-text"
        >When checked, the cursor will focus the search bar when the table loads
        (useful for tables inside modals so users can type immediately).</span
      >
    </div>
    }
    <!-- Dynamic Tabs: Tab sets (conditional menus) editor - replaces generic tabsConfig for this component -->
    @if (component.name === 'DynamicTabsComponent') {
    <div class="form-group tab-sets-section">
      <label>Tab sets (conditional menus)</label>
      <p class="help-text">
        Define who sees which tabs. First matching rule wins. Use "Default" for
        everyone else.
      </p>
      <div class="tab-set-rules">
        @for (rule of tabSetRules; track rule; let ri = $index) {
        <div class="tab-set-rule">
          <div class="rule-header">
            <span class="rule-label">Rule {{ ri + 1 }}</span>
            <button
              type="button"
              (click)="removeTabSetRule(ri)"
              [disabled]="tabSetRules.length <= 1"
            >
              Remove rule
            </button>
          </div>
          <div class="rule-condition">
            <div class="form-group">
              <label>Who sees these tabs</label>
              <app-edit-modal-native-select
                [value]="rule.condition.auth"
                [options]="tabSetAuthOptions"
                (valueChange)="onTabSetAuthSelected(rule, $event)"
              />
            </div>
            @if (isTabSetDataSourceAuth(rule.condition.auth)) {
            <div class="form-group">
              <label>Data source</label>
              <app-edit-modal-native-select
                selectClass="data-source-select"
                [value]="rule.condition.dataSource"
                [options]="
                  toSelectOptions(
                    tabSetDataSources,
                    'Select data source...'
                  )
                "
                (valueChange)="rule.condition.dataSource = $event"
              />
            </div>
            } @if (rule.condition.auth === 'logged-in') {
            <div class="form-group">
              <label>Roles (optional)</label>
              <div class="role-checkboxes">
                @for (role of tabSetAvailableRoles; track role) {
                <label class="role-check">
                  <input
                    type="checkbox"
                    [checked]="getRolesForRule(rule).includes(role)"
                    (change)="toggleRuleRole(ri, role)"
                  />
                  {{ capitalizeFirstLetter(role) }}
                </label>
                }
              </div>
            </div>
            }
            <div class="form-group">
              <label class="default-check">
                <input
                  type="checkbox"
                  [checked]="rule.isDefault"
                  (change)="setRuleDefault(ri, !rule.isDefault)"
                />
                Use as default (show when no other rule matches)
              </label>
            </div>
          </div>
          <div class="rule-tabs">
            <label>Tabs</label>
            <div class="tab-rows">
              @for (tab of rule.tabs; track tab; let ti = $index) {
              <div class="tab-row">
                <input
                  type="text"
                  [value]="tab.text"
                  (input)="tab.text = nativeInputValue($event)"
                  placeholder="Label"
                  class="tab-label-input"
                />
                <input
                  type="text"
                  [value]="tab.slug"
                  (input)="tab.slug = nativeInputValue($event)"
                  placeholder="Slug"
                  class="tab-slug-input"
                />
                <div class="tab-row-actions">
                  <button
                    type="button"
                    (click)="moveTabInRule(ri, ti, ti - 1)"
                    [disabled]="ti === 0"
                  >
                    ↑
                  </button>
                  <button
                    type="button"
                    (click)="moveTabInRule(ri, ti, ti + 1)"
                    [disabled]="ti >= rule.tabs.length - 1"
                  >
                    ↓
                  </button>
                  <button
                    type="button"
                    (click)="removeTabFromRule(ri, ti)"
                  >
                    Remove
                  </button>
                </div>
              </div>
              }
            </div>
            <button type="button" (click)="addTabToRule(ri)">
              Add tab
            </button>
          </div>
        </div>
        }
      </div>
      <button type="button" (click)="addTabSetRule()">
        Add rule
      </button>
    </div>
    <div class="form-group tab-sets-section always-visible-tabs-section">
      <label>Always visible tabs (data source)</label>
      <p class="help-text">
        Tabs added here are merged into the user's tab bar when the selected
        data source returns true — regardless of which rule matched. Use e.g.
        <code>duna_groups_enabled</code> for brugergrupperinger or
        <code>duna_group_calendar_enabled</code> for gruppe-kalender.
      </p>
      <div class="tab-rows">
        @for (tab of alwaysVisibleTabs; track tab; let ai = $index) {
        <div class="tab-row always-visible-row">
          <input
            type="text"
            [value]="tab.text"
            (input)="tab.text = nativeInputValue($event)"
            placeholder="Label"
            class="tab-label-input"
          />
          <input
            type="text"
            [value]="tab.slug"
            (input)="tab.slug = nativeInputValue($event)"
            placeholder="Slug (e.g. tab/user-groups)"
            class="tab-slug-input"
          />
          <app-edit-modal-native-select
            selectClass="data-source-select"
            [value]="tab.dataSource"
            [options]="
              toSelectOptions(tabSetDataSources, 'Select data source...')
            "
            (valueChange)="tab.dataSource = $event"
          />
          <div class="tab-row-actions">
            <button
              type="button"
              (click)="moveAlwaysVisibleTab(ai, ai - 1)"
              [disabled]="ai === 0"
            >
              ↑
            </button>
            <button
              type="button"
              (click)="moveAlwaysVisibleTab(ai, ai + 1)"
              [disabled]="ai >= alwaysVisibleTabs.length - 1"
            >
              ↓
            </button>
            <button
              type="button"
              (click)="removeAlwaysVisibleTab(ai)"
            >
              Remove
            </button>
          </div>
        </div>
        }
      </div>
      <button type="button" (click)="addAlwaysVisibleTab()">
        Add always-visible tab
      </button>
    </div>
    } @for (input of componentInputEntries(); track input.key) { @if
    (input.key !== 'tabsConfig' || component.name !== 'DynamicTabsComponent') {
    <div class="form-group">
      <label [for]="input.key"
        >{{ input.value.displayText || input.key }}:</label
      >
      @switch (input.value.type) { @case ('text') {
      <input
        [id]="input.key"
        type="text"
        [value]="input.value.value"
        (input)="input.value.value = nativeInputValue($event)"
      />
      } @case ('select') {
      <app-edit-modal-native-select
        [selectId]="input.key"
        [value]="input.value.value"
        [options]="toSelectOptions(input.value.options)"
        (valueChange)="input.value.value = $event"
      />
      }
      <!-- Add type="textarea" which is just a simple textarea input -->
      @case ('textarea') {
      <textarea
        [id]="input.key"
        [value]="input.value.value"
        (input)="input.value.value = nativeInputValue($event)"
      ></textarea>
      } @case ('HTMLText') {
      <div class="ck-main-container">
        @if (isHTMLTextEditor()) { @for (event of getSelectedComponentEvents();
        track event) {
        <div class="form-group">
          <label>({{ event }}):</label>
          <input
            type="text"
            [value]="componentProperties['(' + event + ')']"
            (input)="
              componentProperties['(' + event + ')'] = nativeInputValue($event)
            "
            [placeholder]="'Enter ' + event + ' handler'"
          />
        </div>
        } }
        <div class="editor-container editor-container_classic-editor">
          <div class="editor-container__editor">
            @if (isLayoutReady) {
            <ckeditor
              [editor]="Editor"
              [config]="editorConfig"
              [data]="input.value.value || ''"
              (change)="onCkEditorChange(input, $event)"
              (ready)="onEditorReady($event)"
            >
            </ckeditor>
            }
          </div>
        </div>
      </div>
      } @case ('boolean') {
      <input
        [id]="input.key"
        type="checkbox"
        [checked]="input.value.value"
        (change)="input.value.value = nativeCheckboxChecked($event)"
      />
      } @case ('JSON') {
      <div>
        <textarea
          [id]="input.key"
          [value]="input.value.value"
          #jsonInput
          (input)="
            input.value.value = jsonInput.value;
            validateJSON(input, jsonInput.value)
          "
          [class.invalid-json]="isJsonInvalid(input.key)"
          rows="100"
        >
        </textarea>
      </div>
      } @case ('surveyJSON') {
      @if (codeBundledSurveyFormId) {
      <div class="bundled-survey-form-notice">
        <p>
          Denne formular hentes fra kildekoden og kan ikke redigeres i
          template-generator.
        </p>
        <p>
          Rediger JSON i:
          <code>{{ codeBundledSurveyFormSourcePath }}</code>
        </p>
      </div>
      } @else {
      <div class="survey-creator-container">
        <survey-creator [model]="surveyCreator"></survey-creator>
      </div>
      } } }
      <!-- Add description/help text if available -->
      @if (input.value.description) {
      <div class="help-text">
        {{ input.value.description }}
      </div>
      }
    </div>
    } }
  </div>
  }

  <div class="form-group">
    <label>Only visible to Roles:</label>
    <div class="container">
      <div class="list">
        <h3>Available Roles</h3>
        <div
          cdkDropList
          [cdkDropListData]="availableRoles"
          class="item-list"
          (cdkDropListDropped)="dropRole($event)"
          [cdkDropListConnectedTo]="['selected-roles']"
          id="available-roles"
        >
          @for (role of availableRoles; track role) {
          <div cdkDrag class="item">
            {{ capitalizeFirstLetter(role) }}
          </div>
          }
        </div>
        <button (click)="moveRolesTo(availableRoles, selectedRoles)">➔</button>
      </div>

      <div class="list">
        <h3>Selected Roles</h3>
        <div
          cdkDropList
          [cdkDropListData]="selectedRoles"
          class="item-list"
          (cdkDropListDropped)="dropRole($event)"
          [cdkDropListConnectedTo]="['available-roles']"
          id="selected-roles"
        >
          @for (role of selectedRoles; track role) {
          <div cdkDrag class="item">
            {{ capitalizeFirstLetter(role) }}
          </div>
          }
        </div>
        <button (click)="moveRolesTo(selectedRoles, availableRoles)">⬅</button>
      </div>
    </div>
  </div>

  <!-- Permission-based Visibility -->
  <div class="form-group permission-section">
    <label for="enablePermissionCheck"
      >Enable Permission-based Visibility:</label
    >
    <input
      id="enablePermissionCheck"
      type="checkbox"
      [checked]="enablePermissionCheck"
      (change)="enablePermissionCheck = nativeCheckboxChecked($event)"
    />
    <span class="help-text"
      >Use a custom function to determine visibility instead of/in addition to
      role-based visibility</span
    >
  </div>

  @if (enablePermissionCheck) {
  <div class="form-group">
    <label for="permissionFunction">Permission Function:</label>
    <app-edit-modal-native-select
      selectId="permissionFunction"
      [value]="selectedPermissionFunction"
      [options]="permissionSelectOptions()"
      (valueChange)="selectedPermissionFunction = $event"
    />
    @if (selectedPermissionFunction) {
    <div class="permission-function-info">
      <strong>Description:</strong>
      {{ getPermissionDescription(selectedPermissionFunction) }}<br />
      <strong>Requires Context:</strong>
      {{ requiresPermissionContext(selectedPermissionFunction) ? "Yes" : "No" }}
    </div>
    }
  </div>
  } @if (enablePermissionCheck &&
  requiresPermissionContext(selectedPermissionFunction)) {
  <div class="form-group">
    <label for="permissionContextFields">Context Fields (JSON):</label>
    <textarea
      id="permissionContextFields"
      [value]="permissionContextFields"
      (input)="permissionContextFields = nativeInputValue($event)"
      placeholder='{"eventId": "{modalData.eventId}", "userId": "{currentUser.id}"}'
      rows="3"
    >
    </textarea>
    <div class="context-field-help">
      Specify the context data to pass to the permission function. You can use
      placeholders like:
      <ul>
        <li>
          <code>{{ permissionExamples.modalData }}</code> - Data from the modal
          that opened this component
        </li>
        <li>
          <code>{{ permissionExamples.currentUser }}</code> - Current user's ID
        </li>
        <li>
          <code>{{ permissionExamples.routeParams }}</code> - Route parameter
        </li>
        <li>Any other dynamic values your component needs</li>
      </ul>
    </div>
  </div>
  }

  <div class="modal-footer">
    <button type="button" (click)="close()">Cancel</button>
    <button type="button" color="primary" (click)="save()">Save</button>
  </div>
</div>
